// @flow
import {
  LOGIN,
} from '../actions/login';


const initialState = {
  status: 0,
  isLogin: false,
};

export default function (state: Object = initialState, action: Object) {
  switch (action.type) {
    case LOGIN:
      return Object.assign({}, state, {
        status: action.payload.status,
        isLogin: action.payload.login,
      });
    default:
      return state;
  }
}
